import { render, staticRenderFns } from "./BikeInfo.vue?vue&type=template&id=7cb18a04"
import script from "./BikeInfo.vue?vue&type=script&lang=js"
export * from "./BikeInfo.vue?vue&type=script&lang=js"
import style0 from "./BikeInfo.vue?vue&type=style&index=0&id=7cb18a04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports